// Module
var code = "<tr> <td><img src=\"<%- flagPath %>\" style=vertical-align:middle;width:16px;height:auto title=\"<%- geo %>\"/> <%- geo %></td> <% if (ltv) { %> <td class=text-right>$<%- ltv.toFixed(4) %></td> <% } %> <td class=text-right>$<%- parseFloat(cpc).toFixed(4) %></td> </tr> ";
// Exports
module.exports = code;